/**
 * Festivos de Colombia de cualquier año, calculados: no hay listas que actualizar cada año (Ley 51 de 1983).
 * - De fecha fija: 1 de enero, 1 de mayo, 20 de julio, 7 de agosto, 8 y 25 de diciembre.
 * - Los que se corren al lunes siguiente (Ley Emiliani): Reyes (6 ene), San José (19 mar), San Pedro y
 *   San Pablo (29 jun), Asunción (15 ago), Día de la Raza (12 oct), Todos los Santos (1 nov) e
 *   Independencia de Cartagena (11 nov).
 * - Los que dependen de la Pascua: Jueves y Viernes Santo, y Ascensión, Corpus Christi y Sagrado Corazón,
 *   que también se corren al lunes.
 */

const MS_DIA = 24 * 60 * 60 * 1000;

/** Domingo de Pascua, en milisegundos UTC (algoritmo anónimo gregoriano, de Meeus). */
function domingoDePascua(anio) {
    const a = anio % 19;
    const b = Math.floor(anio / 100);
    const c = anio % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const mes = Math.floor((h + l - 7 * m + 114) / 31);
    const dia = ((h + l - 7 * m + 114) % 31) + 1;
    return Date.UTC(anio, mes - 1, dia);
}

/** El festivo que no cae en lunes se corre al lunes siguiente. */
function alLunes(fecha) {
    const diaSemana = new Date(fecha).getUTCDay();
    return diaSemana === 1 ? fecha : fecha + ((8 - diaSemana) % 7) * MS_DIA;
}

const aTexto = (fecha) => new Date(fecha).toISOString().slice(0, 10);

const festivosPorAnio = {};

/**
 * Los festivos del año, como «AAAA-MM-DD».
 * @param {number} anio
 * @returns {Set<string>}
 */
export function festivosColombia(anio) {
    if (festivosPorAnio[anio]) return festivosPorAnio[anio];
    const fija = (mes, dia) => Date.UTC(anio, mes - 1, dia);
    const pascua = domingoDePascua(anio);
    const despuesDePascua = (dias) => pascua + dias * MS_DIA;
    const fechas = [
        fija(1, 1), fija(5, 1), fija(7, 20), fija(8, 7), fija(12, 8), fija(12, 25),
        alLunes(fija(1, 6)), alLunes(fija(3, 19)), alLunes(fija(6, 29)), alLunes(fija(8, 15)),
        alLunes(fija(10, 12)), alLunes(fija(11, 1)), alLunes(fija(11, 11)),
        despuesDePascua(-3), despuesDePascua(-2),
        alLunes(despuesDePascua(39)), alLunes(despuesDePascua(60)), alLunes(despuesDePascua(68)),
    ];
    festivosPorAnio[anio] = new Set(fechas.map(aTexto));
    return festivosPorAnio[anio];
}

/**
 * Si la fecha es festivo en Colombia.
 * @param {string} fecha - «AAAA-MM-DD».
 * @returns {boolean}
 */
export function esFestivoColombia(fecha) {
    return festivosColombia(Number(fecha.slice(0, 4))).has(fecha);
}
